import i18next from 'i18next'
import moment from 'moment'
import { Dialog } from 'primereact/dialog'
import { ProgressSpinner } from 'primereact/progressspinner'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Moment from 'react-moment'
import { useHistory } from 'react-router-dom'
import warningIconBlue from '../../assets/icons/warning-icon-blue.svg'
import warningIcon from '../../assets/icons/warning-icon.svg'
import logo from '../../assets/images/koc-logo.svg'
import HomeOfficeService from '../../service/HomeOfficeService'
// import NotificationService from '../../service/NotificationService'
import PlanService from '../../service/PlanService'
import { ReservationMeta } from '../../types/FloorType'
import { IRemoteOfficeType } from '../../types/MainType'
import DateUtil from '../../utils/DateUtil'
import Button1 from '../ui/Button1'
import failedImage from './../../assets/images/failed-image.svg'
import notificationSuccess from './../../assets/images/notification-success.svg'
import notificationCalendar from './../../assets/images/remote-plan-confirm-image.png'
import './NotificationModal.scss'

const NotificationModal = (props: {
  display: boolean
  onHide: () => void
  onSubmit: (e: React.MouseEvent<HTMLButtonElement>) => void
  isSuccess: boolean
  meta: ReservationMeta | undefined
  selectedType: IRemoteOfficeType
  types: IRemoteOfficeType[]
}) => {
  const { t } = useTranslation()
  const case1 = t('remote-texts.case1')
  const case2 = t('remote-texts.case2')
  const case3 = t('remote-texts.case3')
  const case4 = t('remote-texts.case4')
  const case5 = t('remote-texts.case5')
  const case6 = t('remote-texts.case6')
  const case7 = t('remote-texts.case7')
  const case8 = `${t('remote-texts.first-part')} ${moment(props.meta?.startDate).format('DD.MM.YYYY')}-${moment(
    props.meta?.endDate
  ).format('DD.MM.YYYY')} ${t('remote-texts.second-part')} "${
    props.selectedType && (i18next.language === 'tr' ? props.selectedType.displayedText : props.selectedType.en)
  }"${t('remote-texts.third-part')}`
  const [success, setSuccess] = useState<boolean>(props.isSuccess)
  const [hasAway, setHasAway] = useState<boolean>(false)
  const [hasCommon, setHasCommon] = useState<boolean>(false)
  const [hasOffice, setHasOffice] = useState<boolean>(false)
  const [warning, setWarning] = useState<string>('')
  const [readyControl, setReadyControl] = useState<boolean>(false)
  const [loading, setLoading] = useState<boolean>(true)
  const [dayOffVisible, setDayOffVisible] = useState<boolean>(true)
  const [offDayMessage, setOffDayMessage] = useState<string[]>()
  const [hasError, setHasError] = useState(false)
  const [message, setMessage] = useState('')
  const history = useHistory()

  useEffect(() => {
    getMyPlanList()
  }, [])

  useEffect(() => {
    if (readyControl) {
      controlPlan()
    }
  }, [readyControl])

  const getMyPlanList = () => {
    setOffDayMessage(undefined)
    setDayOffVisible(true)
    PlanService.GetMyPlanList(
      DateUtil.formatDateToString(props.meta?.startDate! as Date),
      DateUtil.formatDateToString(props.meta?.endDate as Date)
    )
      .then((response) => {
        let tempList: string[] = []
        response.data?.forEach((res) => {
          if (res.planType === 7 && !res.dayOffIsReservable) {
            setDayOffVisible(!res.dayOffIsReservable)
            i18next.language === 'en' ? tempList.push(res.descriptionDayOffEn) : tempList.push(res.descriptionDayOffTr)
            setOffDayMessage(tempList)
          }
          console.log('success', success)
          switch (res.planType) {
            case 1:
              setHasAway(true)
              break
            case 2:
              setHasOffice(true)
              break
            case 5:
              setHasOffice(true)
              break
            case 4:
              setHasCommon(true)
              break
            case 6:
              setHasCommon(true)
              break
            default:
              break
          }
        })
      })
      .then(() => {
        setReadyControl(true)
      })
  }

  const controlPlan = () => {
    if (!hasOffice && !hasCommon) setWarning(case1)
    if (hasOffice && !hasCommon && !hasAway) setWarning(case2)
    if (!hasOffice && hasCommon && !hasAway) setWarning(case3)
    if (!hasOffice && hasCommon && hasAway) setWarning(case4)
    if (hasOffice && !hasCommon && hasAway) setWarning(case5)
    if (hasOffice && hasCommon && !hasAway) setWarning(case6)
    if (hasOffice && hasCommon && hasAway) setWarning(case7)
    if (!hasOffice && !hasCommon && props.types.length) setWarning(case8)
    setLoading(false)
  }

  const save = () => {
    if (props.meta?.startDate !== undefined && props.meta?.endDate !== undefined) {
      setLoading(true)
      let req =
        props.types.length > 0
          ? {
              ReservationDate: DateUtil.formatDateToString(props.meta?.startDate as Date),
              ReservationEndDate: DateUtil.formatDateToString(props.meta?.endDate as Date),
              RemoteOfficeTypeId: props.selectedType.id,
            }
          : {
              ReservationDate: DateUtil.formatDateToString(props.meta?.startDate as Date),
              ReservationEndDate: DateUtil.formatDateToString(props.meta?.endDate as Date),
            }
      HomeOfficeService.createHomePlan(req)
        .then((response) => {
          setSuccess(true)
          setHasError(!response.data.isTransactionSuccess)
          if (!response.data.isTransactionSuccess) {
            // Backend'den gelen mesaj kodunu dictionary'den çevir
            const errorCode = response.data.message
            const translatedMessage = t(errorCode, { ns: 'dictionary' })
            setMessage(translatedMessage)
          }
          setLoading(false)
        })
        .catch((e) => {
          console.error(e)
          setLoading(false)
          // BusinessException mesajı gösterme, modalı kapat
          // Interceptor hata popup'ı gösterecek
          props.onHide()
        })
    }
  }

  const goCalendar = () => {
    history.push({
      pathname: '/calendar',
    })
  }

  const renderFooter = () => {
    return (
      <div className="row justify-content-center">
        {!success ? (
          <>
            <div className={'col-6 pe-1 ps-1'}>
              <Button1
                class={'button-white-sm'}
                label={t('buttons.cancel')}
                onClick={() => props.onHide()}
                disabled={false}
              />
            </div>
            <div className={'col-6 pe-1 ps-1'}>
              <Button1 class={'button-blue-sm'} label={t('buttons.confirm')} onClick={save} disabled={false} />
            </div>
          </>
        ) : hasError ? (
          <>
            <div className={'col-6 pe-1 ps-1'}>
              <Button1 class={'button-blue-sm'} label={t('buttons.ok')} onClick={props.onHide} disabled={false} />
            </div>
          </>
        ) : (
          <>
            <div className={'col-6 pe-1 ps-1'}>
              <Button1
                class={'button-blue-sm'}
                label={t('buttons.go-to-calendar')}
                onClick={goCalendar}
                disabled={false}
              />
            </div>
          </>
        )}
      </div>
    )
  }

  const renderOffDayFooter = () => {
    return (
      <div className="row justify-content-center">
        <>
          <div className={'col-6 pe-1 ps-1'}>
            <Button1 class={'button-blue-sm'} label={t('buttons.ok')} onClick={() => props.onHide()} disabled={false} />
          </div>
        </>
      </div>
    )
  }

  const calendarTemplate = () => {
    return (
      <>
        <div className={'row justify-content-center mb-2'}>
          <img className={'not-cal-pic'} src={notificationCalendar} alt="icon" />
        </div>
        <div className={'row mb-3'}>
          <span className={'not-cal-head'}>{t('dashboard.remote-office-notification')}</span>
        </div>
        <div className={'row mb-3'}>
          <span className={'not-cal-content'}>
            {warning}
            <br />
            <br />
            <strong>Tarih:</strong> <Moment format={'DD.MM.YYYY'}>{props.meta?.startDate}</Moment>
            {DateUtil.dateEquals(props.meta?.startDate as Date, props.meta?.endDate as Date) ? null : (
              <>
                {' '}
                - <Moment format={'DD.MM.YYYY'}>{props.meta?.endDate}</Moment>
              </>
            )}
          </span>
        </div>
      </>
    )
  }

  const dayOffTemplate = () => {
    return (
      <>
        {offDayMessage?.length === 1 ? (
          <div style={{ paddingTop: '1rem', paddingBottom: '1rem' }}>
            <div className={'row justify-content-center mb-3'}>
              <img className={'not-cal-pic'} src={warningIconBlue} alt="icon" />
            </div>
            <div className={'row mb-3'}>
              <span className={'not-cal-head'}>{t('overlaypanel-texts.info-header')}</span>
            </div>
            <div className={'row mb-3'} style={{ textAlign: 'center', overflow: 'auto', maxHeight: '16vh' }}>
              <p>
                {offDayMessage?.map((item) => (
                  <span className={'dayOffList'}>{item}</span>
                ))}
              </p>
            </div>
          </div>
        ) : (
          <div style={{ paddingTop: '1rem', paddingBottom: '1rem' }}>
            <div className={'row justify-content-center mb-3'}>
              <img className={'not-cal-pic'} src={notificationCalendar} alt="icon" />
            </div>
            <div className={'row mb-3'}>
              <span className={'not-cal-head'}>{t('dashboard.remote-office-notification')}</span>
            </div>
            <div className={'row mb-3'} style={{ textAlign: 'center', overflow: 'auto', maxHeight: '16vh' }}>
              <p className={'not-cal-head-dayOff'}>{warning}</p>
              {offDayMessage?.map((item) => (
                <span>
                  <img src={warningIcon} alt="icon" />
                  <span className={'dayOffList'}>{item}</span>
                </span>
              ))}
            </div>
          </div>
        )}
      </>
    )
  }

  const successTemplate = () => {
    return (
      <div style={{ paddingTop: '1rem', paddingBottom: '1rem' }}>
        <div className={'row justify-content-center mb-3'}>
          <img className={'not-cal-pic'} src={!hasError ? notificationSuccess : failedImage} alt="icon" />
        </div>
        <div className={'row mb-3'}>
          <span className={'not-cal-head'}>
            {!hasError ? t('dashboard.remote-office-notification') : t('failed.failed-reservation')}
          </span>
        </div>
        <div className={'row mb-3'}>
          <span className={'not-cal-content'}>{!hasError ? t('success-text.remote-office-success') : message}</span>
        </div>
      </div>
    )
  }

  return (
    <div className="notification-modal">
      {!loading && (
        <Dialog
          contentClassName={'notification-modal-content'}
          visible={props.display}
          onHide={props.onHide}
          breakpoints={{ '576px': '80vw' }}
          style={{ width: '400px' }}
          footer={offDayMessage?.length === 1 ? renderOffDayFooter() : renderFooter()}
          draggable={false}
          resizable={false}>
          {success ? successTemplate() : !dayOffVisible ? calendarTemplate() : dayOffTemplate()}
        </Dialog>
      )}
      {loading && (
        <div
          className={'loading'}
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
            minHeight: '100vh',
            zIndex: 1102,
          }}>
          <ProgressSpinner style={{ position: 'absolute', width: '120px', zIndex: 1102 }} />
          <img alt="Yükleniyor..." style={{ position: 'absolute', width: '60px', zIndex: 1102 }} src={logo} />
        </div>
      )}
    </div>
  )
}
export default NotificationModal
